import { render, staticRenderFns } from "./PollingDetail.vue?vue&type=template&id=6cc31ce8"
import script from "./PollingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PollingDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports